export default "__VITE_ASSET__I7hzm$To__"